<template>
  <div>
    <div class="columns is-gapless has-background-white is-minH50p is-border-top is-marginless-bottom">
      <div
        v-if="isBounced || isRefused || isNegligence"
        class="column is-narrow has-background-danger is-flex is-padding-small">
        <span class="icon has-text-white is-self-centered"><i class="fas fa-exclamation-circle"></i></span>
      </div>
      <div
        v-else-if="hasSendingDate"
        class="column is-narrow has-background-success is-flex is-padding-small">
        <span class="icon has-text-white is-self-centered"><i class="fas fa-check-circle"></i></span>
      </div>
      <div
        v-else
        class="column is-narrow has-background-danger is-flex is-padding-small">
        <span class="icon has-text-white is-self-centered"><i class="fas fa-clock"></i></span>
      </div>
      <div class="column is-padding-left is-self-centered">
        <span class="is-size-6 is-uppercase has-text-weight-medium">{{ lineText }}</span>
        <span class="is-size-6 has-text-grey">&nbsp;({{ buyer.email }})</span>
      </div>
      <div
        v-if="isAdmin && letters.length > 1"
        class="column has-text-right is-self-stretched">
        <button
          :disabled="!isAdmin && !validBuyers"
          @click="openPreview"
          data-tooltip="Contact non valide"
          :class="{'tooltip is-tooltip-left' : !validBuyer}"
          class="button is-minH100 is-dark is-small is-radiusless w150p">
          <span v-if="!loadingDoc"><span><i class="fas fa-cogs is-margin-xsmall"></i></span> <span class="is-size-7">GÉNÉRER COURRIER</span></span>
          <span v-else><i class="fas fa-spinner fa-spin"></i></span>
        </button>
      </div>
      <div
        @click="openModal()"
        class="has-cursor-pointer is-border-left column is-padding-small is-narrow is-self-centered is-minW154p">
        <span class="is-size-7 is-uppercase">GESTION RECOMMANDÉ</span>
      </div>
      <div
        v-if="index >= 1"
        class="column is-narrow has-text-right is-border-left">
        <button
          @click="deleteLre"
          class="button is-grey is-inverted is-borderless is-minH50p is-radiusless is-w50p has-text-primary">
          <span
            v-if="!loadingDelete"
            class="icon">
            <i class="fal fa-trash-alt"></i>
          </span>
          <span v-else>
            <i class="fas fa-spinner fa-spin"></i>
          </span>
        </button>
      </div>
      <div
        v-if="isAdmin && letters.length > 1 && index == 0"
        class="column is-narrow has-text-right is-border-left">
        <div class="is-w50p"></div>
      </div>
    </div>
  </div>
</template>

<script>
// il faut changer currentSru avec les champs en dessous pour avoir les différentes vues.
// registered: 'RegisteredMail',
// demat: 'DematSru',
// before: 'BeforeDematSru'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { Error } from '@/mixins'
export default {
  name: 'SruItem',
  mixins: [Error],
  props: {
    stepLre: {
      type: Array
    },
    buyers: {
      type: Array
    },
    source: {
      type: Object
    },
    index: {
      type: Number
    },
    requestElem: {
      type: Object
    },
    letters: {
      type: Array
    },
    appelDeFondIndex: {
      type: [Number, String]
    },
    sruIndex: {
      type: [Number, String]
    }
  },
  data () {
    return {
      loadingDoc: false,
      loadingDelete: false,
      currentSru: 'registered'
    }
  },
  computed: {
    ...mapGetters(['isAdmin']),
    /**
      * return text
      * @returns {string}
      */
    lineText () {
      let text = ''
      if (this.hasSendingDate) {
        if (this.isRefused) {
          text = `Refusée par le destinataire le ${moment(this.buyerLre.details.refused_date).format('DD/MM/YYYY')}`
        } else if (this.isBounced) {
          text = `Erreur lors de la réception`
        } else if (this.isNegligence) {
          text = `Erreur: négligence`
        } else if (this.isAr) {
          text = `Réceptionné le ${moment(this.buyerLre.details.view_date).format('DD/MM/YYYY')}`
        } else {
          text = `Recommandé envoyé le ${moment(this.buyerLre.created_on).format('DD/MM/YYYY')}`
        }
      } else {
        text = `Recommandé en attente`
      }
      return text
    },
    /**
      * buyer is valid
      * @returns {boolean}
      */
    validBuyer () {
      return this.buyer.is_complete
    },
    /**
      * current buyer
      * @returns {object}
      */
    buyer () {
      let result = this.buyers.filter(x => x.pk === this.source.buyer_pk)
      return result[0]
    },
    /**
      * current buyer lre
      * @returns {object}
      */
    buyerLre () {
      if (this.buyer) {
        return this.stepLre.find(x => {
          return x.details.buyer === this.buyer.pk
        })
      } else {
        return null
      }
    },
    /**
      * lre created on
      * @returns {string}
      */
    hasSendingDate () {
      if (this.buyerLre) {
        return this.buyerLre.created_on
      } else {
        return null
      }
    },
    /**
      * lre status is bounced
      * @returns {boolean}
      */
    isBounced () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'bounced'
      } else {
        return false
      }
    },
    /**
      * lre status is bounced
      * @returns {boolean}
      */
    isNegligence () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'negligence'
      } else {
        return false
      }
    },
    /**
      * lre status is refused
      * @returns {boolean}
      */
    isRefused () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'refused'
      } else {
        return false
      }
    },
    /**
      * lre status is ar
      * @returns {boolean}
      */
    isAr () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'ar'
      } else {
        return false
      }
    },
    /**
      * lre status is recipient_update
      * @returns {boolean}
      */
    isRecipientUpdate () {
      if (this.buyerLre) {
        return this.buyerLre.status === 'recipient_update'
      } else {
        return false
      }
    }
  },
  methods: {
    /**
      * open preview
      */
    async openPreview () {
      this.loadingDoc = true
      let request = await this.getPdf()
      this.loadingDoc = false
      let params = {
        link: request.data
      }
      this.$store.commit('setModal', { mode: 'DOCUMENT_PREVIEW_SAAS', params })
    },
    /**
      * get pdf
      */
    getPdf () {
      let url = `pdf/adf/${this.$route.params.id}/${this.source.buyer_pk}/${this.requestElem.step_uuid}`
      return this.$api.axios.get(url)
    },
    /**
      * delete lre
      */
    async deleteLre () {
      this.loadingDelete = true
      try {
        let data = await this.$api.axios.delete(`reservations/${this.requestElem.adv_pk}/adf/${this.requestElem.step_uuid}/${this.source.buyer_pk}`)
        let payload = {
          construstion_steps: data
        }
        await this.$store.dispatch('patchAdvConstructionStep', payload)
        this.$toasted.global.success('Courrier Recommandé supprimé')
        this.$emit('getAppelDeFondLre')
      } catch (err) {
        this.handleError(err)
        console.log(err)
      } finally {
        this.loadingDelete = false
      }
    },
    /**
      * open modal lre
      */
    openModal () {
      let params = {
        from: 'adf',
        currentSru: this.currentSru,
        requestElem: this.requestElem,
        buyerPk: this.buyer.pk,
        appelDeFondIndex: this.appelDeFondIndex,
        sruIndex: this.sruIndex,
        lre: this.buyerLre
      }
      this.$store.commit('setModal', { mode: 'RECOMMENDED_MANAGEMENT', params })
    }
  }
}
</script>
